import { Heart, Meh, Frown } from "lucide-react";
import { cn } from "@/lib/utils";

export type ItemRatingValue = 'loved' | 'fine' | 'disliked';

interface ItemRatingProps {
  rating: ItemRatingValue;
  size?: "xs" | "sm" | "md" | "lg";
  showLabel?: boolean;
  className?: string;
}

export default function ItemRating({ 
  rating, 
  size = "sm",
  showLabel = false,
  className 
}: ItemRatingProps) {
  const sizeClasses = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5", 
    lg: "w-6 h-6"
  };

  const textSizeClasses = {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg"
  };

  const getRatingConfig = () => {
    switch (rating) {
      case 'loved':
        return {
          icon: Heart,
          label: 'Loved',
          colorClass: 'text-green-500',
          fillClass: 'fill-green-500'
        };
      case 'fine':
        return {
          icon: Meh,
          label: 'Fine',
          colorClass: 'text-yellow-500',
          fillClass: ''
        };
      case 'disliked':
        return {
          icon: Frown,
          label: 'Disliked',
          colorClass: 'text-red-500',
          fillClass: ''
        };
    }
  };

  const config = getRatingConfig();
  const Icon = config.icon;

  return (
    <div className={cn("flex items-center gap-1", className)} data-testid="item-rating">
      <Icon 
        className={cn(
          sizeClasses[size], 
          config.colorClass,
          config.fillClass
        )} 
      />
      {showLabel && (
        <span className={cn(textSizeClasses[size], "font-medium", config.colorClass)}>
          {config.label}
        </span>
      )}
    </div>
  );
}
